﻿$(function () {
    $(document).on('click', '.open-sign-up-modal', function (e) {

        e.preventDefault();
        var modal = $('.email-modal');
        var listName = '';
        if (typeof $(e.target).attr('data-list-name') !== 'undefined') {
            $('input[name=list-name]').val($(e.target).attr('data-list-name'));
        }

        var documentHeight = $(document).height();
        var w = $(window).width(),
            t = $(window).height();
        $('.email-modal .error').empty();
        modal.height(documentHeight);
        $('.modal-form').show();
        modal.show();
        var leftpx = w / 2 - $('.email-modal .overlay-window').outerWidth() / 2;
        var toppx = $(window).scrollTop() + (t / 2) - $('.email-modal .overlay-window').outerHeight() / 2;

        //POSITION THE LOGIN WINDOW
        $('.email-modal .overlay-window').css({
            left: leftpx,
            top: toppx
        }).addClass("tint2");

        $('html').addClass('ModalOn');


    });
    $(window).resize(function () {
        var w = $(window).width(),
            t = $(window).height();
        //POSITION THE LOGIN WINDOW
        $('.email-modal .overlay-window').css({
            left: (w / 2) - ($('.email-modal .overlay-window').width() / 2),
            top: $(window).scrollTop() + ((t / 2) - ($('.email-modal .overlay-window').height() / 2))
        });
    });
    $('.email-modal .close-modal').click(function (e) {
        e.preventDefault();
        $('.email-modal').hide();
        $('html').removeClass('ModalOn');
        $('.email-modal .sucess').remove();
        $('.email-modal .erroor').remove();
    });

    $(document).on('click', '.copy-link', function (e) {
        e.preventDefault();
        var button = $(this);
        var currentUrl = window.location.href;

        navigator.clipboard.writeText(currentUrl).then(function() {
            button.text('Copied!');
            setTimeout(function() {
                button.text('Copy link');
            }, 2000);
        }).catch(function(err) {
            console.error('Failed to copy URL: ', err);
        });
    });
});